var $name="statuses",$path="configs/statuses.js",$this={$name,$path,};/**
 * Statuses of form submit
 */
module.exports = {
  accepted: 'accepted',
  redirected: 'redirected',
  rejected: 'rejected',
  serverError: 'serverError',
};
